import type { GetExploreContent200Page } from './getExploreContent200Page';

export type GetExploreContent200 = {
  code?: string;
  message?: string;
  page?: GetExploreContent200Page;
  success?: boolean;
};
